'use client';

import Link from 'next/link';

export default function HomePageError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="min-h-screen flex items-center justify-center bg-[#F7F7F3] px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-extrabold text-[#373A36] mb-3">
          Algo salio mal
        </h1>
        <p className="text-[#666] mb-8">
          No pudimos cargar la pagina. Puede ser un problema temporal.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={reset}
            className="btn-primary"
          >
            Intentar de nuevo
          </button>
          <Link href="/" className="btn-secondary">
            Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
